import Swiper from 'swiper';

$(function () {
    var tariffSlider = new Swiper('[data-selector="tariff-slider"]', {
        slidesPerView: 4.6,
        spaceBetween: 15,
        initialSlide: 2,
        centeredSlides: true,
        simulateTouch: false,
        prevButton: '[data-selector="tariff-slider-prev-btn"]',
        nextButton: '[data-selector="tariff-slider-next-btn"]',
        breakpoints: {
            1500: {
                slidesPerView: 3.8,
                spaceBetween: 15,
                centeredSlides: true,
                initialSlide: 1,
            },
            1264: {
                slidesPerView: 3.5,
                spaceBetween: 15,
                centeredSlides: true,
                initialSlide: 1,
            },
            767: {
                slidesPerView: 2.5,
                spaceBetween: 15,
                centeredSlides: true,
                initialSlide: 0,
            },
            499: {
                slidesPerView: 1.5,
                spaceBetween: 15,
                centeredSlides: true,
                initialSlide: 0,
            },
        },
    });
});